import React from "react";
import { Route, Routes } from "react-router-dom";
import RtuSettingDetailPage from "../RtuSettingDetailPage";
import RtuSettingPage from "../RtuSettingPage";

export default function RtuSettingRoutes() {
  return (
    <>
      <Routes>
        <Route path="*" element={<RtuSettingPage />} />
        <Route path="/detail/" element={<RtuSettingDetailPage />} />
        <Route path="/detail/:id/" element={<RtuSettingDetailPage />} />
      </Routes>
    </>
  );
}
